import React from "react";
import {
  Layout,
  Typography,
 
  Divider,
} from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

function CodeDownload() {
  return (
    <Content className="app-content">
      <Title level={4}>Source Code</Title>
      <Paragraph>Coming soon!</Paragraph>
    </Content>
  );
}

export default CodeDownload;
